<template>
  <div id="app" v-cloak>
    <app-header v-show="showHeadBar" :title="pageTitle" :showBtn="showBtn" :step="backStep"></app-header>
    <!-- 缓存首页 -->
    <keepAlive include="country">
      <router-view v-show="loadReady"></router-view>
    </keepAlive>
    <van-tabbar route v-if="showTabbar" fixed :safe-area-inset-bottom="true">
      <!-- <van-tabbar-item replace to="/order" icon="balance-list">
        <span>Order</span>
      </van-tabbar-item> -->
      <van-tabbar-item replace to="/myGiftCard" icon="point-gift">
        <span>My Gift</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/coupons" icon="coupon">
        <span>Coupon</span>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Config } from 'vue-superset'
import { Locale } from 'vant'
import enUS from 'vant/lib/locale/lang/en-US'
import VConsole from 'vconsole'

Locale.use('en-US', enUS)
export default {
  data () {
    return {
      pageTitle: '',
      backStep: 'back',
      showBtn: true,
      showHeadBar: false,
      country: '',
      loadReady: false,
      transitionName: '',
      showTabbar: false,
      icon: {
        home_active: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/home-active.png',
        home: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/home.png',
        order_active: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/order-active.png',
        order: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/order.png',
        mycard_active: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/mycard-active.png',
        mycard: 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/mycard.png'
      }
    }
  },
  watch: {
    // 监听路由变化
    $route (to, from) {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
      this.$cux.loadend()
      this.showHeadBar = !to.path.includes('home') && !to.path.includes('login') && !to.path.includes('activity') && !to.path.includes('couponDetail') && !to.path.includes('logoutApp')
      this.showBtn = !to.fullPath.includes('register')
      this.pageTitle = to.meta.title
      if (to.fullPath.includes('reset')) {
        this.pageTitle = 'Reset Password'
      }
      if (to.path === '/order' || to.path === '/myGiftCard' || to.path === '/coupons') {
        this.showTabbar = true
      } else {
        this.showTabbar = false
      }

      if (to.path.includes('giveFriends')) { // 送礼页面
        this.backStep = 'myGiftCard'
      } else {
        if (to.path.includes('receiveGift') || to.path.includes('myGiftCard') || to.path.includes('coupons')) {
          this.backStep = 'home'
        } else {
          if (to.path.includes('orderDetail') || to.path.includes('couponDetail')) {
            this.backStep = to.query.active ? 'myGiftCard:' + to.query.active : 'back'
          } else {
            this.backStep = 'back'
          }
        }
      }
    }
  },
  mounted () {
    // 友盟统计添加
    const script = document.createElement('script')
    script.src = 'https://s4.cnzz.com/z_stat.php?id=1279721946&web_id=1279721946' // 该路径为点击统计代码后，页面中第一个 文字统计 script代码
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  created () {
    // 默认缓存配置
    if (this.$route.query.memberSource) {
      this.$util.storageSet('local', 'memberSource', this.$route.query.memberSource)
    }
    if (!this.$util.storageGet('local', 'phoneCode')) { // 国家码
      this.$util.storageSet('local', 'phoneCode', '65')
    }
    if (!this.$util.storageGet('local', 'country')) { // 国家
      this.$util.storageSet('local', 'country', 'Singapore')
    }
    if (!this.$util.storageGet('local', 'marketImg')) { // 市场图片
      this.$util.storageSet('local', 'marketImg', 'https://ebuypaas-test.e-buychina.com/paas-ui-olvp/icon/Singapore.png')
    }
    if (!this.$util.storageGet('local', 'marketId')) { // 市场ID
      this.$util.storageSet('local', 'marketId', '1')
    }
    if (!this.$util.storageGet('local', 'picture')) { // facebook头像
      this.$util.storageSet('local', 'picture', 'https://ebuyimg.e-mallchina.com/olvp/logo.png')
    }
    // 全局配置
    const env = process.env.NODE_ENV
    console.log('env:', env)
    if (env === 'release') {
      // eslint-disable-next-line no-new
      new VConsole()
    }
    let httpPath = env === 'development' ? 'https://uat-paas-app-olvp.e-buychina.com/paas/app/' : '/paas/app/'
    let appId = env === 'production' ? 'ebuycbd665bf3891' : 'ebuycbd665bf3891'
    Config.custom = {
      lang: 'en',
      appId: appId, // 应用ID，必配项
      appName: 'paas-app-olvp', // 应用名称，必配项
      timeout: 10000,
      interfacePathMap: { // 接口路径映射
        'paas-app-olvp': {
          publicPath: httpPath
        }
      }
    }

    // 图片预加载
    this.preloadImg()

    // 禁用ios缩放
    document.addEventListener('touchstart', function (event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    let lastTouchEnd = 0
    document.addEventListener('touchend', function (event) {
      let now = (new Date()).getTime()
      if (now - lastTouchEnd <= 300) {
        event.preventDefault()
      }
      lastTouchEnd = now
    }, false)
    document.addEventListener('gesturestart', function (event) {
      event.preventDefault()
    })

    // token过期回调
    this.$http.onTokenTimeout = () => {
      this.$router.replace({
        path: `/login?backPath=${encodeURIComponent(this.$route.fullPath)}`
      })
    }

    // 加载facebook sdk
    // 279328376432388 生产测试 548876789097998 本地测试 545159009734839 本地测试 680265285989571 生产
    if (document.domain.includes('e-buychina.com') || document.domain.includes('ugiftglobal.com')) {
      let id = document.domain.includes('sg-paas-ui-olvp') || document.domain.includes('e-buychina.com') || document.domain.includes('ugiftglobal.com') ? '680265285989571' : '680265285989571'
      this.$facebook.loadSdk({
        appId: id,
        version: 'v4.0',
        lang: 'en_US'
      })
    }

    // 获取本地存储语言 防止刷新浏览器丢失配置
    // let lang = Util.storageGet('local', 'lang')
    // if (lang) {
    //   this.$i18n.locale = lang
    // } else {
    //   lang = navigator.language || navigator.userLanguage
    //   lang = lang.substr(0, 2)
    //   Util.storageSet('local', 'lang', lang)
    //   this.$i18n.locale = lang
    // }
    this.$i18n.locale = 'en'
  },
  methods: {
    preloadImg () {
      let imgs = [
        require('@/assets/img/UgiftLogoTM.png'),
        require('@/assets/img/home-bg.jpg'),
        require('@/assets/img/fb.png'),
        require('@/assets/img/wa.png'),
        require('@/assets/img/browser.png'),
        require('@/assets/img/home-mine.png'),
        require('@/assets/img/app-title.png')
      ]

      for (let img of imgs) {
        let image = new Image()
        image.onload = () => {
          this.count++
        }
        image.src = img
        if (image.length === this.count) {
          this.loadReady = true
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  [v-cloak] {
    display: none;
  }

  #app {
    width: 100%;
    max-width: 480px;
    height: 100%;
    text-align: center;
    color: #272727;
    font-size: 14px;
    background: #fff;
    font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Roboto", sans-serif;
    -webkit-font-smoothing: antialiased;
    margin: 0 auto;
  }

  .van-tabbar .van-tabbar-item img {
    width: 27px;
    height: 25px;
  }

  /**
* 路由切换动画
*/
  .slide-right-enter-active,
  .slide-right-leave-active,
  .slide-left-enter-active,
  .slide-left-leave-active {
    will-change: transform;
    -webkit-will-change: transform;
    transition: all 500ms;
    -webkit-transition: all 500ms;
    position: absolute;
  }

  .slide-right-enter {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
    -webkit-transform: translate3d(-100%, 0, 0);
  }

  .slide-right-leave-active {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
    -webkit-transform: translate3d(100%, 0, 0);
  }

  .slide-left-enter {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
    -webkit-transform: translate3d(100%, 0, 0);
  }

  .slide-left-leave-active {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
    -webkit-transform: translate3d(-100%, 0, 0);
  }
  .van-tabbar-item__icon {
    font-size: 20px;
  }
</style>
